import * as React from 'react';
import SiteLicense from './SiteLicense/SiteLicense';

export default class LicenseContainerComponent extends React.Component<any, any> {
  render() {
    return (
      <SiteLicense />
    );
  }

  componentWillMount() {
    document.getElementById('app')!.classList.add('background-style');
  }

  componentWillUnmount() {
    document.getElementById('app')!.classList.remove('background-style');
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/components/LicenseContainer.tsx